import { Route } from "react-router-dom";
import { PropertyDetailsPage } from "./PropertyDetailsPage/PropertyDetailsPage";
import {
  PropertyDetailsPageErrorBoundary,
  PropertyDetailsPageLoader,
} from "./PropertyDetailsPage/loaders/PropertyDetailsPageLoader";
import { ProtectedRoute } from "~/context/ProtectedRoute";
import * as APITypes from "~/API";
import { ROUTES } from "~/utils";

export const PropertyPagesRoutes = () => {
  return (
    <Route
      path={ROUTES.propertyDetails}
      loader={PropertyDetailsPageLoader}
      ErrorBoundary={PropertyDetailsPageErrorBoundary}
      element={
        <ProtectedRoute
          roles={[
            APITypes.TenantStatusType.Active,
            APITypes.TenantStatusType.InActive,
          ]}
        >
          <PropertyDetailsPage />
        </ProtectedRoute>
      }
    />
  );
};
